var _rect, _rect2, _rect3, _circle, _mask, _path, _circle2, _mask2, _path2, _circle3, _rect4, _rect5, _circle4, _rect6, _rect7, _circle5, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 464,
    viewBox: "0 0 238 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 415,
    height: 143,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 160.5,
    width: 415,
    height: 295,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 431,
    height: 463,
    rx: 23.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 55.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_1488_2472",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 30C80 26.6863 82.6939 23.9667 85.9886 24.3211C93.3335 25.1111 100.47 27.349 106.978 30.9268C115.244 35.471 122.228 42.0295 127.282 49.9937C132.337 57.9579 135.297 67.0698 135.889 76.4837C136.482 85.8977 134.687 95.3088 130.67 103.844C126.654 112.379 120.547 119.761 112.916 125.305C105.285 130.849 96.3769 134.376 87.0187 135.558C77.6604 136.741 68.1552 135.54 59.385 132.067C52.4798 129.334 46.2065 125.261 40.916 120.105C38.5428 117.793 38.9211 113.983 41.4743 111.871L51.2136 103.814C53.7669 101.702 57.5197 102.115 60.0789 104.22C62.5881 106.284 65.4123 107.953 68.4556 109.158C73.3669 111.102 78.6898 111.775 83.9304 111.113C89.171 110.451 94.1595 108.476 98.4329 105.371C102.706 102.266 106.126 98.132 108.375 93.3524C110.624 88.5729 111.63 83.3027 111.298 78.0309C110.966 72.7591 109.308 67.6564 106.478 63.1965C103.648 58.7365 99.7367 55.0638 95.1078 52.519C92.2395 50.9422 89.1531 49.8301 85.9635 49.2122C82.7103 48.5821 80 45.9537 80 42.64L80 30Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 30C80 26.6863 82.6939 23.9667 85.9886 24.3211C93.3335 25.1111 100.47 27.349 106.978 30.9268C115.244 35.471 122.228 42.0295 127.282 49.9937C132.337 57.9579 135.297 67.0698 135.889 76.4837C136.482 85.8977 134.687 95.3088 130.67 103.844C126.654 112.379 120.547 119.761 112.916 125.305C105.285 130.849 96.3769 134.376 87.0187 135.558C77.6604 136.741 68.1552 135.54 59.385 132.067C52.4798 129.334 46.2065 125.261 40.916 120.105C38.5428 117.793 38.9211 113.983 41.4743 111.871L51.2136 103.814C53.7669 101.702 57.5197 102.115 60.0789 104.22C62.5881 106.284 65.4123 107.953 68.4556 109.158C73.3669 111.102 78.6898 111.775 83.9304 111.113C89.171 110.451 94.1595 108.476 98.4329 105.371C102.706 102.266 106.126 98.132 108.375 93.3524C110.624 88.5729 111.63 83.3027 111.298 78.0309C110.966 72.7591 109.308 67.6564 106.478 63.1965C103.648 58.7365 99.7367 55.0638 95.1078 52.519C92.2395 50.9422 89.1531 49.8301 85.9635 49.2122C82.7103 48.5821 80 45.9537 80 42.64L80 30Z",
    fill: "#9966FF",
    fillOpacity: 0.16,
    stroke: "#9966FF",
    strokeOpacity: 0.32,
    strokeWidth: 2,
    mask: "url(#path-5-inside-1_1488_2472)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 80,
    r: 55.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_1488_2472",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216 30C216 26.6863 218.694 23.9667 221.989 24.3211C231.682 25.3636 240.973 28.924 248.916 34.695C258.483 41.6462 265.605 51.4478 269.259 62.695C272.914 73.9423 272.914 86.0577 269.259 97.3049C265.605 108.552 258.483 118.354 248.916 125.305C239.349 132.256 227.826 136 216 136C204.174 136 192.651 132.256 183.084 125.305C173.517 118.354 166.395 108.552 162.741 97.3049C159.707 87.9671 159.192 78.0309 161.196 68.4899C161.877 65.247 165.296 63.5252 168.447 64.5491L180.469 68.4551C183.62 69.4791 185.282 72.869 184.876 76.1578C184.317 80.6857 184.75 85.306 186.175 89.6908C188.221 95.9892 192.209 101.478 197.567 105.371C202.925 109.263 209.377 111.36 216 111.36C222.623 111.36 229.075 109.263 234.433 105.371C239.791 101.478 243.779 95.9892 245.825 89.6908C247.872 83.3923 247.872 76.6077 245.825 70.3092C243.779 64.0108 239.791 58.5219 234.433 54.6292C230.703 51.9193 226.443 50.0799 221.964 49.2122C218.71 48.582 216 45.9537 216 42.64L216 30Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216 30C216 26.6863 218.694 23.9667 221.989 24.3211C231.682 25.3636 240.973 28.924 248.916 34.695C258.483 41.6462 265.605 51.4478 269.259 62.695C272.914 73.9423 272.914 86.0577 269.259 97.3049C265.605 108.552 258.483 118.354 248.916 125.305C239.349 132.256 227.826 136 216 136C204.174 136 192.651 132.256 183.084 125.305C173.517 118.354 166.395 108.552 162.741 97.3049C159.707 87.9671 159.192 78.0309 161.196 68.4899C161.877 65.247 165.296 63.5252 168.447 64.5491L180.469 68.4551C183.62 69.4791 185.282 72.869 184.876 76.1578C184.317 80.6857 184.75 85.306 186.175 89.6908C188.221 95.9892 192.209 101.478 197.567 105.371C202.925 109.263 209.377 111.36 216 111.36C222.623 111.36 229.075 109.263 234.433 105.371C239.791 101.478 243.779 95.9892 245.825 89.6908C247.872 83.3923 247.872 76.6077 245.825 70.3092C243.779 64.0108 239.791 58.5219 234.433 54.6292C230.703 51.9193 226.443 50.0799 221.964 49.2122C218.71 48.582 216 45.9537 216 42.64L216 30Z",
    fill: "#1959E6",
    fillOpacity: 0.16,
    stroke: "#1959E6",
    strokeOpacity: 0.32,
    strokeWidth: 2,
    mask: "url(#path-7-inside-2_1488_2472)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 188,
    r: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 176.5,
    width: 159,
    height: 23,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 208.5,
    width: 47,
    height: 39,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 284,
    r: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 272.5,
    width: 159,
    height: 23,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 304.5,
    width: 95,
    height: 39,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 380,
    r: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 368.5,
    width: 159,
    height: 23,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 400.5,
    width: 63,
    height: 39,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicRight);
export default __webpack_public_path__ + "static/media/graphic-right.c4aa6ae1a3b7195c427dbaf8d9fb6b44.svg";
export { ForwardRef as ReactComponent };